import CalendarMonthOutlined from "@mui/icons-material/CalendarMonthOutlined";
import ArrowForwardOutlined from "@mui/icons-material/ArrowForwardOutlined";
import CalComDialog from "../../components/calComDialog/calComDialog.jsx";
import ConsultationInterstitialLayout from "./consultationInterstitial/ConsultationInterstitialLayout.jsx";

// Multi-company specialist roster is a completely different Cal.com booking
// page from the single-company BookingSlots widget's customer agents, so this
// step opens CalComDialog directly instead of embedding <BookingSlots />.
const CAL_COM_MULTIPLE_URL =
  "https://cal.com/nikoletta-bodnar-bookeepie/tobbceges-ugyintezes-bokkeeepie-idopontfoglalas";

const MULTI_COMPANY_INTERSTITIAL_OPTIONS = [
  {
    value: "consultation",
    titleKey: "searchflow.multicompanyinterstitialconsultationtitle",
    descKey: "searchflow.multicompanyinterstitialconsultationdesc",
    Icon: CalendarMonthOutlined,
    // Not marked `recommended` — nudging users toward booking a call over
    // self-service is a product decision, not something to default silently.
    recommended: false,
  },
  {
    value: "continue",
    titleKey: "searchflow.multicompanyinterstitialcontinuetitle",
    descKey: "searchflow.multicompanyinterstitialcontinuedesc",
    Icon: ArrowForwardOutlined,
    recommended: false,
  },
];

/**
 * Shown after CommonMoreBranch resolves to "multiplecompany". Next requires a
 * selection (same pattern as CommonMoreBranch itself); which action Next
 * performs depends on that selection — "continue" proceeds to the Typeform
 * exit, "consultation" opens the Cal.com booking dialog instead (owned by the
 * parent flow controller so the footer's Next button can drive it directly,
 * rather than requiring a separate in-card button click).
 */
const NewMultiCompanyInterstitial = ({
  selection,
  onSelectionChange,
  bookingDialogOpen,
  onBookingDialogOpenChange,
}) => {
  return (
    <>
      <ConsultationInterstitialLayout
        titleKey="searchflow.multicompanyinterstitialtitle"
        subtitleKey="searchflow.multicompanyinterstitialsubtitle"
        options={MULTI_COMPANY_INTERSTITIAL_OPTIONS}
        selection={selection}
        onSelectionChange={onSelectionChange}
      />
      <CalComDialog
        open={bookingDialogOpen}
        onClose={() => onBookingDialogOpenChange(false)}
        url={CAL_COM_MULTIPLE_URL}
      />
    </>
  );
};

export default NewMultiCompanyInterstitial;
